import React from 'react';
import { ListChecks } from 'lucide-react';
import { AdminPageHeader, AdminGuideCallout } from '../../components/admin/guidance';
import { ADMIN_PAGE_GUIDES } from '../../utils/adminPageGuides';

const AdminContent = () => {
  const guide = ADMIN_PAGE_GUIDES.content;

  return (
    <div className="space-y-5">
      <AdminPageHeader
        title="Content Management"
        subtitle="Moderate and manage site content across the platform."
      />

      <AdminGuideCallout title={guide.title} steps={guide.steps} icon={ListChecks} />

      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm p-4 sm:p-5">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Admin content moderation page.
        </p>
      </div>
    </div>
  );
};

export default AdminContent;
